module.exports = __webpack_public_path__ + "2ad0b57ff71f081bfe35390badc4af97.svg";